module.exports = __webpack_public_path__ + "img/casepic2.6d7d6a47.png";